export class Etat {
  id: string;
  cle: number;
  document: number;
  type: string;
  typeDocument: string;
  niveauCarburant: number;
  materielCle: number;
  materielNature: string;
  kilometrage: number;
  elementEtatInterieur: any[]; // TODO: can be declared as a better type
  elementEtatExterieur: any[]; // TODO: can be declared as a better type
  reponsesCheckList: any[]; // TODO: can be declared as a better type
  note: string;

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/model/etat.ts